module.exports = __webpack_public_path__ + "static/media/04510025-IqT0wSgs.6832388d.JPG";